import React from 'react'
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Footer from './comp/Footer'
import Header from './comp/Header'
import "./misu.scss"
function App() {
  return (
    <div>
      <Header/>
      <Footer/>
    </div>
  )
}

export default App
